import React from "react";
import S from "./styles";
import FieldErrors from "../field-errors/FieldErrors";

type Props = {
  errors?: string[];
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input = (props: Props) => {
  const { errors } = props;

  const hasErrors = errors !== undefined && errors.length > 0;

  return (
    <div>
      <S.Input {...props} invalid={hasErrors} />
      {hasErrors && <FieldErrors errors={errors!} />}
    </div>
  );
};

export default Input;
